export const adjustContactFormSubmitButton = () => {
  const submitButton =
    document.querySelector<HTMLButtonElement>('.wpcf7-submit');
  if (submitButton) {
    submitButton.disabled = false;
  }
};
